import { z } from "zod";

export const NoticiaSchema = z.object({
  id: z.string().or(z.number()).optional(),
  titulo: z.string().trim().min(1, "El título es obligatorio"),
  bajada: z.string().trim().optional().nullable(),
  fijado: z
    .union([z.boolean(), z.string()])
    .transform((val) => (val === true || val === "true" ? true : false)),
  fecha_publicacion: z.string().optional().nullable(),
  descripcion: z.string().optional().nullable(),
  etiqueta: z.string().trim().min(1, "La categoría es obligatoria"),
  tipo: z.string().trim().min(1, "El tipo de publicación es obligatorio"),
  url: z.string().trim().optional().nullable(),
  img: z.union([z.string(), z.any()]).optional().nullable(),
  id_img: z.string().optional().nullable(),
  preview: z.union([z.string(), z.any()]).optional().nullable(),
  image_preview: z.any().optional().nullable(),
});

export const NoticiaCreateSchema = NoticiaSchema.omit({ id: true });
export const NoticiaUpdateSchema = NoticiaSchema;

export const parseNoticia = (data) => NoticiaSchema.parse(data);
export const safeParseNoticia = (data) => NoticiaSchema.safeParse(data);

export class Noticia {
  constructor(data = {}) {
    this.id = data.id ?? null;
    this.titulo = data.titulo ?? "";
    this.bajada = data.bajada ?? null;
    this.fijado = Boolean(data.fijado);
    this.fecha_publicacion = data.fecha_publicacion ?? null;
    this.descripcion = data.descripcion ?? null;
    this.etiqueta = data.etiqueta ?? "";
    this.tipo = data.tipo ?? "";
    this.url = data.url ?? null;
    this.img = data.img ?? null;
    this.id_img = data.id_img ?? null;
    this.preview = data.preview ?? null;
  }

  toJSON() {
    return {
      id: this.id,
      titulo: this.titulo,
      bajada: this.bajada,
      fijado: this.fijado,
      fecha_publicacion: this.fecha_publicacion,
      descripcion: this.descripcion,
      etiqueta: this.etiqueta,
      tipo: this.tipo,
      url: this.url,
      img: this.img,
      id_img: this.id_img,
      preview: this.preview,
    };
  }
}

export default Noticia;